import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';
import debounce from 'lodash/debounce';

let countersInitialised = false;

function countersAreInitialised() {
    return countersInitialised;
}

function activateCounter(item, index) {
    const relatedContentCounters = item.querySelectorAll('.js-related-content-counter');

    // Remove the 'is-active' class for whichever counter is currently active.
    [...relatedContentCounters].forEach(counter => {
        if(counter.classList.contains('is-active')) {
            counter.classList.remove('is-active');
        }

        // Add 'is-active' class to the slide that we just changed to.
        if(counter.getAttribute('data-controls-slide') == index) {
            counter.classList.add('is-active');
        }
    });
}

function showCounters(item) {
    if(!countersAreInitialised()) {
        // Grab all the carousel items.
        const relatedContentItems = item.querySelectorAll('.js-related-content-item');

        const relatedContentCountersEl = item.querySelector('.js-related-content-counters');

        // Loop through the slides and create a counter for each slide.
        for (let i = 0; i < relatedContentItems.length; i++) {

            let relatedContentCounter = document.createElement('li');
            relatedContentCounter.classList.add('article-grid__counter', 'js-related-content-counter');
            relatedContentCounter.setAttribute('data-controls-slide', i);

            if(i == 0) {
                relatedContentCounter.classList.add('is-active');
            }

            relatedContentCountersEl.appendChild(relatedContentCounter);
        }

        countersInitialised = true;
    }
}

function registerCounterClickEvents(item, carousel) {
    // Grab all the carousel items.
    const relatedContentCounters = item.querySelectorAll('.js-related-content-counter');

    // Loop through the counters and add an event listener to go to the selected slide.
    [...relatedContentCounters].forEach((counter, i) => {
        counter.addEventListener('click', () => {
            carousel.goTo(i, () => activateCounter(item, i));
        });
    });
}

function shouldCarouselAtScreenSize( items ) {
    if ( mmMatches('desktop') ) {
        if ( items > 3 ) {
            return true;
        }
    } else if ( mmMatches('desktop-max') && mmMatches('tablet') ) {
        if  ( items > 2 ) {
            return true;
        }
    } else if ( mmMatches('tablet-max') ) {
        if ( items > 1 ) {
            return true;
        }
    }
    return false;
}

const relatedContent = document.querySelectorAll('.js-related-content');


relatedContent.forEach(item => {

    initialiseCarousel( item );

});

function handlePreviousClick(currentSlide, carousel) {
    const   currentSlideIndex = currentSlide,
            nextSlideIndex = currentSlideIndex - 1;

    if ( nextSlideIndex > -1 ) {
        carousel.goTo(nextSlideIndex);
    }
}

function handleNextClick(currentSlide, carouselLength, carousel) {
    const   currentSlideIndex = currentSlide,
            nextSlideIndex = currentSlideIndex + 1;

    if ( nextSlideIndex < carouselLength ) {
        carousel.goTo(nextSlideIndex);
    }
}

function disableButton(button) {
    if(button) {
        button.classList.add('is-disabled');
        button.disabled = true;
    }
}

function enableButton(button) {
    if(button) {
        button.classList.remove('is-disabled');
        button.disabled = false;
    }
}

function normaliseHeights ( item ) {
    const relatedContentItems = item.querySelectorAll('.js-related-content-item');
    let largestHeight = 0;

    [...relatedContentItems].forEach( function ( relatedContentItem ) {
        const currentItemHeight = relatedContentItem.offsetHeight;

        relatedContentItem.style.height = 'auto';
        if ( currentItemHeight > largestHeight ) largestHeight = currentItemHeight;
    } );

    [...relatedContentItems].forEach( function ( relatedContentItem ) {
        relatedContentItem.style.height = `${largestHeight}px`;
    } );
}

function initialiseCarousel(item) {

    const itemsList = item.querySelector('.js-related-content-list');

    if ( itemsList.classList.contains('is-carousel') ) {
        return false;
    }

    const   items = itemsList.children.length,
            item_elements = itemsList.children,
            carouselNextPrev = item.querySelector('.js-next-prev-buttons'),
            relatedContentCountersEl = item.querySelector('.js-related-content-counters');

    if ( shouldCarouselAtScreenSize( items ) ) {

        const   prevButton = carouselNextPrev.querySelector('.js-prev'),
                nextButton = carouselNextPrev.querySelector('.js-next');

                item.classList.add('is-carousel');
                itemsList.classList.add('is-carousel');

        const carousel = new Siema({
            selector: itemsList,
            duration: 200,
            easing: 'ease-out',
            perPage: {
                0: 1,
                768: 2,
                1024: 3
            },
            startIndex: 0,
            draggable: true,
            multipleDrag: true,
            threshold: 20,
            loop: false,
            onInit: () => {
                showCounters(item);
                // window.addEventListener('resize', debounce(showCounters, 250));
                disableButton(prevButton);

                // normaliseHeights( item );
            },
            onChange: () => {
                activateCounter(item, carousel.currentSlide);

                if(carousel.currentSlide > 0) {
                    enableButton(prevButton);
                } else {
                    disableButton(prevButton);
                }

                if(carousel.currentSlide + carousel.perPage == items) {
                    disableButton(nextButton);
                } else {
                    enableButton(nextButton);
                }
            }
        });

        // window.addEventListener('resize', function ( event ) { normaliseHeights( item ) } );

        // Grab all the counters that were created.
        const relatedContentCounters = item.querySelectorAll('.js-related-content-counter');

        // Loop through the counters and add an event listener to go to the selected slide.
        [...relatedContentCounters].forEach((counter, i) => {
            counter.addEventListener('click', () => {
                carousel.goTo(i, () => activateCounter(item, i));
            });
        });

        carouselNextPrev.classList.remove('is-hidden');
        relatedContentCountersEl.classList.remove('is-hidden');

        registerCounterClickEvents(item, carousel);
        window.addEventListener('resize', debounce(() => {
            registerCounterClickEvents(item);
        }, 250));

        window.addEventListener('resize', debounce( function () {
            carousel.destroy(true);

            itemsList.classList.remove('is-carousel');
        }))

        // Add listeners for arrows
        prevButton.addEventListener('click', function () {
            handlePreviousClick(carousel.currentSlide, carousel)
        });

        nextButton.addEventListener('click', function () {
            handleNextClick(carousel.currentSlide, items, carousel)
        });

    } else {

        carouselNextPrev.classList.add('is-hidden');
        relatedContentCountersEl.classList.add('is-hidden');

        if ( itemsList.classList.contains('is-carousel') ) {

            itemsList.classList.remove('is-carousel');

        }

    }

    window.addEventListener('resize', debounce( function () {
        relatedContent.forEach(item => {
            initialiseCarousel( item );
        });
    }, 250));

}
